/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: oujinfa oujinfa@100efly.com
 * @Date: 2024-01-22 10:48:37
 * @LastEditTime: 2024-04-30 16:48:02
 * @Descripttion: file content
 */
import React, { ReactNode, useEffect, useState } from 'react'
import Header from '../base/Header'
import Footer from '../base/Footer'
import BreadCrumb from '../base/BreadCrumb'
import style from './index.module.scss'
import { useSelector } from 'react-redux'
import { CommStateType } from '@/redux/reducer/commReducer'
import { useLocation } from 'react-router-dom'
import { SHOW_FOOTER } from '@/globalConfig'


interface LayoutProps {
	children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
	const token = useSelector<CommStateType, string>(state => state.comm.token)
	const location = useLocation()
	const [show, setShow] = useState(false)
	const [showHead, setShowHead] = useState(false)
	const whiteList = ['/tea/check/overview']
	const headerWhilteList = ['/login']
	useEffect(() => {
		// const isShow = location.pathname.split('/').length > 3
		setShow(whiteList.includes(location.pathname))
		setShowHead(!headerWhilteList.includes(location.pathname))
	}, [location])
	return (
		<React.Fragment>
			{showHead ?
				<>
					<Header />
					<div className={[style.container, !token && style.login].join(' ')}>
						{show && <BreadCrumb></BreadCrumb>}
						<div className={style.content}>{children}</div>
					</div>
				</>
				:
				<div className={[style.container1, !token && style.login1].join(' ')}>
					{show && <BreadCrumb></BreadCrumb>}
					<div className={style.content1}>{children}</div>
				</div>}
			{SHOW_FOOTER && !token && <Footer />}
		</React.Fragment>
	)
}
